import getApi from '../../api/apisauceConfig'
import { serializeQuestionTemplate } from './mapper/questionTemplates.mapper'
import { QuestionTemplateMutationPayload } from './mapper/questionTemplates.model'
import { QuestionTemplate } from '../../model/Questionnaire'

export const updateQuestionTemplate = (id: number, payload: QuestionTemplateMutationPayload) =>
  getApi().put<QuestionTemplate>(`/question_templates/${id}`, serializeQuestionTemplate(payload))
